"use client";
import SectionWrapper, {
  SectionWrapperProps,
} from "@/commonComponents/section-wrapper";
import EnhancedSwiper from "@cc/enhanced-swiper";
import InitiativeListingCard, {
  InitiativeListingCardProps,
} from "@cc/initiative-listing-card";
import SvgIconArrow from "@c/intermediate/icons/arrowIcon";
import MLink from "@cc/m-link";
import { H5_1 } from "@theme/components/typography.fontvariant";
import SwiperNavigationButton from "@cc/swiper-navigation-button";
import { Navigation } from "swiper/modules";
import { startCase } from "lodash";
import { Typography } from "@mui/material";
import { deepmerge } from "@mui/utils";

export type InitiativeSwiperListingProps = {
  data: {
    label: string;
    labelHref?: string;
    initiatives: InitiativeListingCardProps[];
  }[];
  disableNavigation?: boolean;
} & Omit<SectionWrapperProps, "children">;

const InitiativeSwiperListing = (props: InitiativeSwiperListingProps) => {
  const { data, disableNavigation = false, ...restSectionWrapperProps } = props;
  return data.map((item, index) => {
    const { label, labelHref, initiatives } = item;
    const isEvenIndex = index % 2 === 0;
    const companyKey = startCase(label).split(" ").join("-").toLowerCase();
    const nextEl = `${companyKey}-next`;
    const prevEl = `${companyKey}-prev`;
    return (
      <SectionWrapper
        key={index}
        {...deepmerge(
          sectionWrapperDefaultProps(isEvenIndex),
          restSectionWrapperProps,
        )}
      >
        <EnhancedSwiper
          data={initiatives}
          SlideComponent={InitiativeListingCard}
          slidesPerView={3}
          spaceBetween={26}
          modules={disableNavigation ? [] : [Navigation]}
          navigation={{
            enabled: !disableNavigation,
            prevEl: `.${prevEl}`,
            nextEl: `.${nextEl}`,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            576: {
              slidesPerView: 3,
              spaceBetween: 26,
            },
          }}
          // SlideWrapperProps={{
          //   sx: {
          //     // width: "auto",
          //     mr: { xs: 2, md: 3.2 },
          //     "&:last-of-type": {
          //       mr: 0,
          //     },
          //   },
          // }}
          SlideComponentProps={{
            sx: {
              width: "auto",
              maxWidth: "100%",
            },
          }}
          Slots={{
            ContainerStartProps: {
              direction: "row",
              justifyContent: "space-between",
              alignItems: "center",
              pb: { xs: 2, md: 7 },
            },
            ContainerStartChildren: (
              <>
                {labelHref ? (
                  <MLink
                    href={labelHref}
                    variant={"text"}
                    disableRipple
                    endIcon={<SvgIconArrow />}
                    sx={{
                      fontSize: H5_1,
                      whiteSpace: "break-spaces",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {label}
                  </MLink>
                ) : (
                  <Typography fontSize={H5_1}>{label}</Typography>
                )}

                {!disableNavigation && (
                  <SwiperNavigationButton
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                      },
                    }}
                    PrevButtonProps={{
                      className: prevEl,
                    }}
                    NextButtonProps={{
                      className: nextEl,
                    }}
                  />
                )}
              </>
            ),
          }}
        />
      </SectionWrapper>
    );
  });
};

export default InitiativeSwiperListing;

const sectionWrapperDefaultProps = (
  isEven: boolean,
): Omit<SectionWrapperProps, "children"> => ({
  SectionProps: {
    bgcolor: isEven ? "common.white" : "default",
  },
  color: "primary.main",
});
